let Public = new Object();
// 邮箱验证
Public.emailCheck = function (val) {
    var email = val.trim();
    var reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    return reg.test(email);
};
// 手机号验证
Public.phone = function (tel) {
    var phone = tel.trim();
    var reg = /^1\d{10}$/;
    return reg.test(phone);
};

Public.dataLineNumber = function (index, pageData) {
    return pageData.pageno > 1 ? (pageData.pageno - 1) * pageData.pagesize + index + 1 : index + 1
}
// 只能输入数字,限制小数点后n位（正数）
Public.numberFloat = function (val, n = 5) {
    if (val) {
        val = val.replace(/[^0-9.]/g, '');
    }
    if (val.split('.').length > 2) {
        val = val.split('.')[0] + '.' + val.split('.')[1];
    } else if (val.split('.').length == 2) {
        val = val.split('.')[0] + '.' + (val.split('.')[1].length > n ? val.split('.')[1].substr(0, n) : val.split('.')[1]);
    }
    return val
}
// 只能输入数字,限制小数点后n位（包含负数）
Public.numberFloatAll = function (val, n = 5) {
    if (val) {
        var t = val.charAt(0);
        val = val.replace(/[^0-9.]/g, '');

    }
    if (val.split('.').length > 2) {
        val = val.split('.')[0] + '.' + val.split('.')[1];
    } else if (val.split('.').length == 2) {
        val = val.split('.')[0] + '.' + (val.split('.')[1].length > n ? val.split('.')[1].substr(0, n) : val.split('.')[1]);
    }
    if (t == '-') {
        val = '-' + val;
    }
    return val
}

export default Public